import { DesktopDatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import shape1 from "../../assets/admin/png/model-shape-1.png";
import shape2 from "../../assets/admin/png/model-shape-2.png";
import VSNImage from "../../shared/VSNImage";
import VSNLoader from "../../shared/VSNLoader";
import VSNTypography from "../../shared/VSNTypography";

const useStyles = makeStyles((theme) => ({
  heading: {
    position: "sticky",
    top: 0,
    borderBottom: "1px solid var(--primary)",
    padding: "12px 25px",
    margin: "0 -25px",
    backgroundColor: "var(--white)",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      padding: "12px 15px",
      margin: "0 -15px",
    },
    "&:after": {
      position: "absolute",
      content: "''",
      left: 0,
      right: 0,
      height: 25,
      width: "100%",
      bottom: "100%",
      background: "var(--white)",
      zIndex: 8,
    },
    "& svg": {
      borderRadius: "50%",
      [theme.breakpoints.down("md")]: {
        width: 40,
        height: 40,
      },
      [theme.breakpoints.down("sm")]: {
        width: 30,
        height: 30,
      },
    },
    "& h5": {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: "31px",
      marginLeft: 16,
      [theme.breakpoints.down("md")]: {
        fontSize: 18,
        lineHeight: "26px",
        maxWidth: "70%",
      },
    },
  },
  shape: {
    position: "absolute",
    zIndex: -2,
  },
  shape1: {
    top: "20%",
    right: "10%",
  },
  shape2: {
    bottom: "5%",
    left: "0%",
  },
  waiverForm: {
    heading: {
      position: "sticky",
      top: 0,
      borderBottom: "1px solid var(--primary)",
      padding: "12px 25px",
      margin: "0 -25px",
      backgroundColor: "var(--white)",
      zIndex: 2,
      [theme.breakpoints.down("sm")]: {
        padding: "12px 15px",
        margin: "0 -15px",
      },
      "&:after": {
        position: "absolute",
        content: "''",
        left: 0,
        right: 0,
        height: 25,
        width: "100%",
        bottom: "100%",
        background: "var(--white)",
        zIndex: 8,
      },
      "& svg": {
        borderRadius: "50%",
        [theme.breakpoints.down("md")]: {
          width: 40,
          height: 40,
        },
        [theme.breakpoints.down("sm")]: {
          width: 30,
          height: 30,
        },
      },
      "& h5": {
        fontSize: 24,
        fontWeight: 700,
        lineHeight: "31px",
        marginLeft: 16,
        [theme.breakpoints.down("md")]: {
          fontSize: 18,
          lineHeight: "26px",
          maxWidth: "70%",
        },
      },
    },
    shape: {
      position: "absolute",
      zIndex: -2,
    },
    shape1: {
      top: "20%",
      right: "10%",
    },
    shape2: {
      bottom: "5%",
      left: "0%",
    },
    "& .MuiInputBase-input": {
      padding: 10,
    },
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  waiveImages: {
    position: "relative",
    padding: "0 30px",
    "&:not(:last-child):after": {
      content: "'X'",
      position: "absolute",
      top: "50%",
      right: 0,
      transform: "translateY(-50%)",
    },
  },
}));
const ViewWaiverMemberListModal = ({
  fetchWaiverMemberList,
  waiversStatusFormData,
}) => {
  const classes = useStyles();
  return (
    <>
      {fetchWaiverMemberList ? (
        <VSNLoader variant="fullPage" />
      ) : (
        <Box>
          <>
            <VSNImage
              src={shape1}
              alt=""
              className={`${classes.shape} ${classes.shape1}`}
            />
            <VSNImage
              src={shape2}
              alt=""
              className={`${classes.shape} ${classes.shape2}`}
            />

            <Stack
              direction="row"
              alignItems="center"
              className={classes.heading}
            >
              <VSNTypography variant="h5" component="h5" my={1}>
                {waiversStatusFormData?.waiver_name}
              </VSNTypography>
            </Stack>
          </>

          <Box
            sx={{
              marginX: "auto",
              marginY: "10px",
              padding: "10px",
            }}
          >
            <Stack direction="row" justifyContent="center" pb={1}>
              {waiversStatusFormData?.images &&
                waiversStatusFormData?.images?.map((src, index) => (
                  <div className={classes.waiveImages} key={index}>
                    <VSNImage
                      key={index}
                      src={src}
                      alt="logo"
                      height="30px"
                      maxWidth="130px"
                    />
                  </div>
                ))}
            </Stack>

            <form className={classes.waiverForm}>
              <Grid container spacing={2}>
                {waiversStatusFormData?.content?.map((field, index) => {
                  if (field.type === "text") {
                    return (
                      <Grid item xs={12} key={index}>
                        <VSNTypography
                          dangerouslySetInnerHTML={{ __html: field?.title }}
                        />
                      </Grid>
                    );
                  }

                  if (
                    ["textbox", "number", "datepicker", "time"].includes(
                      field.type
                    )
                  ) {
                    return (
                      <Grid item xs={12} sm="auto" key={index}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <VSNTypography
                            sx={{ fontWeight: 600, flex: "none" }}
                            dangerouslySetInnerHTML={{ __html: field?.title }}
                          />

                          {["textbox", "number"].includes(field.type) && (
                            <TextField
                              type={field.type === "number" ? "number" : "text"}
                              variant="outlined"
                              value={waiversStatusFormData[field.key] || ""}
                              fullWidth
                              required
                              disabled
                            />
                          )}

                          {field.type === "datepicker" && (
                            <Stack>
                              <DesktopDatePicker
                                inputFormat="MM/DD/YYYY"
                                value={
                                  waiversStatusFormData[field.key]
                                    ? dayjs(waiversStatusFormData[field.key])
                                    : null
                                }
                                fullWidth
                                disabled
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    fullWidth
                                    disabled
                                  />
                                )}
                              />
                            </Stack>
                          )}

                          {field.type === "time" && (
                            <Stack>
                              <TimePicker
                                value={
                                  waiversStatusFormData[field.key]
                                    ? dayjs(
                                        waiversStatusFormData[field.key],
                                        "HH:mm"
                                      )
                                    : null
                                }
                                fullWidth
                                disabled
                                renderInput={(params) => (
                                  <TextField {...params} required disabled />
                                )}
                              />
                            </Stack>
                          )}
                        </Stack>
                      </Grid>
                    );
                  }

                  if (
                    field.type === "checkbox" ||
                    field.type === "optional_checkbox"
                  ) {
                    return (
                      <Grid item xs={12} key={index}>
                        <FormControl>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  waiversStatusFormData[field.key] || false
                                }
                                disabled
                              />
                            }
                            label={field.title}
                          />
                        </FormControl>
                      </Grid>
                    );
                  }
                  return null;
                })}
              </Grid>
            </form>

            <Grid container spacing={2} pt={3}>
              {waiversStatusFormData?.content?.map((field, index) => {
                if (field.type === "reference") {
                  return (
                    <Grid item xs={12} md={3} key={index}>
                      <VSNTypography
                        dangerouslySetInnerHTML={{ __html: field.title }}
                      />
                    </Grid>
                  );
                }
                return null;
              })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ViewWaiverMemberListModal;
